import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
        // Keep default "New York" if there's an error
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    // Set initial states
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px' // Consider element as "passed" when it's 90% above the viewport
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px' // Consider top section visible when at least 30% is visible
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // When the section is no longer intersecting (scrolled past it)
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // When the top section is visible
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    // Small delay to ensure DOM is fully rendered
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  // Log the state for debugging
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex justify-between items-center" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider" data-id="element-13">WOMEN'S HEALTH</span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
                <path fill="#f0f0f0" d="M103.622 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM167.737 160.624l-4.123 12.684h-13.336l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835h-13.336zM167.737 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM31.908 160.624l-4.123 12.684H14.449l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835H36.031zM31.908 219.081l-3.284 10.134H17.986l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333H35.192z" data-id="element-21" />
              </svg>
            </div>
            <span className="text-sm" data-id="element-22">Trending in the US</span>
          </div>
        </div>
      </div>
      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-23">
        <div className="container mx-auto px-4 py-3" data-id="element-24">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-25">
            WOMEN'S HEALTH | Advertorial
          </p>
        </div>
      </header>
      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-26">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-27">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-28" />
          <p className="font-bold text-sm sm:text-base" data-id="element-29">
            UPDATE: Elivara Compression Leggings Are Selling Out FAST! Grab
            Yours NOW to get up to 40% OFF + Fast FREE Shipping Across the US
          </p>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-31">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-32">
            <div className="py-6 px-0 md:px-4" data-id="element-33">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-34">
                {userCity} Doctors Reveal: Women with PCOS Are Discovering They
                Also Have Lipedema — And Why Their Legs Never Responded to PCOS
                Treatment
              </h1>
              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-35">
                Up to 17 million women in the US have Lipedema — and thousands
                with PCOS are just now learning they have BOTH conditions. A new
                compression breakthrough is helping them finally find relief.
              </p>
              {/* Author and Date */}
              <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6" data-id="element-36">
                <div className="flex items-center" data-id="element-37">
                  <p className="text-sm text-gray-700" data-id="element-38">
                    By Sarah Mitchell, Women's Health | April 29, 2025
                  </p>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-39">
                  <EyeIcon size={16} className="mr-1" data-id="element-40" />
                  <span data-id="element-41">247,891</span>
                </div>
              </div>
              {/* Featured Image */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-42">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hb7663489Vj6W5fHFmd7JR/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_21_%CF%80.%CE%BC..png" alt="Woman looking frustrated while measuring her legs, showing visible disproportionate size compared to her upper body" className="w-full h-auto" data-id="element-43" />
              </div>
              {/* Personal Story Section */}
              <div className="mb-10" data-id="element-44">
                <p className="mb-4" data-id="element-45">
                  I'll never forget the day I finally understood why my PCOS
                  treatments weren't working on my legs.
                </p>
                <p className="mb-4" data-id="element-46">
                  I'd been diagnosed with PCOS five years earlier. I did
                  everything right. I took metformin. I cut carbs. I lost 40
                  pounds.
                </p>
                <p className="mb-4" data-id="element-47">
                  My face slimmed down. My waist got smaller. My arms looked
                  toned.
                </p>
                <p className="mb-4" data-id="element-48">
                  But my legs? They stayed huge. Swollen. Painful. Completely
                  out of proportion with the rest of my body.
                </p>
                <p className="mb-4" data-id="element-49">
                  My doctor kept saying, "Keep following the PCOS protocol. Your
                  hormones need more time to balance."
                </p>
                <p className="mb-4" data-id="element-50">
                  But I'd been following it perfectly for years. And my legs
                  just kept getting worse.
                </p>
                <p className="mb-4 font-semibold" data-id="element-51">Sound familiar?</p>
                <p className="mb-4" data-id="element-52">
                  If you have PCOS and your legs refuse to respond no matter how
                  well you manage your hormones — you need to keep reading.
                </p>
                <p className="mb-4" data-id="element-53">What I discovered changed everything.</p>
              </div>
              {/* The Hidden Condition Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-54">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-55">
                  The Hidden Connection Between PCOS and Lipedema (And Why Your
                  Doctor Probably Missed It)
                </h2>
                {/* Medical Condition Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-56">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m9g7umpbQUcEETPScspXRj/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_23_%CF%80.%CE%BC..png" alt="Medical illustration showing the difference between normal fat tissue and lipedema fat tissue" className="w-full h-auto" data-id="element-57" />
                </div>
                <p className="mb-4" data-id="element-58">
                  It turns out, my leg problem wasn't PCOS fat at all.
                </p>
                <p className="mb-4" data-id="element-59">
                  I had a second condition called lipedema. And my doctor had no
                  idea.
                </p>
                <p className="mb-4" data-id="element-60">
                  According to the National Institutes of Health, lipedema
                  affects 11% of women in the United States. That's roughly 17
                  million women.
                </p>
                <p className="mb-4" data-id="element-61">
                  But here's what researchers are now discovering: Women with
                  PCOS are significantly more likely to have lipedema too.
                </p>
                <p className="mb-4" data-id="element-62">
                  The hormonal imbalances that cause PCOS — insulin resistance,
                  inflammation, hormone disruption — can trigger or worsen
                  lipedema.
                </p>
                <p className="mb-4" data-id="element-63">
                  That's why your legs won't respond to PCOS treatments. You're
                  treating one condition, but you actually have two.
                </p>
                <p className="mb-4" data-id="element-64">Here's what lipedema actually is:</p>
                <p className="mb-4" data-id="element-65">
                  Lipedema is a disorder of fatty tissue. It causes fat to build
                  up abnormally in the legs (and sometimes arms). This creates a
                  disproportionate appearance.
                </p>
                <p className="mb-4" data-id="element-66">
                  The fat cells in lipedema are different from normal fat cells.
                  They're different from PCOS fat cells too. They're
                  dysfunctional. They're inflamed. And they trap fluid in the
                  tissue.
                </p>
                <p className="mb-4" data-id="element-67">The telltale signs include:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-68">
                  <li data-id="element-69">
                    Large legs compared to your upper body (often described as
                    "column-like")
                  </li>
                  <li data-id="element-70">Fat that doesn't respond to PCOS diet protocols</li>
                  <li data-id="element-71">Legs that are painful or tender to touch</li>
                  <li data-id="element-72">Legs that feel heavy</li>
                  <li data-id="element-73">Easy bruising on the legs</li>
                  <li data-id="element-74">Both legs affected equally</li>
                  <li data-id="element-75">Swelling that gets worse as the day goes on</li>
                </ul>
                <p className="mb-4" data-id="element-76">
                  But here's the most frustrating part: Most doctors only look
                  for PCOS. They miss the lipedema completely.
                </p>
                <p className="mb-4" data-id="element-77">
                  They see your hormone levels improving. They see you losing
                  weight in your upper body. They assume the PCOS protocol is
                  working.
                </p>
                <p className="mb-4" data-id="element-78">
                  They don't understand that your legs need a different approach
                  entirely.
                </p>
                <p className="mb-4" data-id="element-79">
                  This isn't about willpower. This isn't about managing your
                  PCOS better. It's about biology.
                </p>
                <p className="mb-4" data-id="element-80">
                  For years, I thought I was failing my PCOS treatment. I
                  thought I wasn't disciplined enough.
                </p>
                <p className="mb-4" data-id="element-81">
                  But once I got my lipedema diagnosis, I realized millions of
                  women with PCOS experience the same thing. The confusion. The
                  frustration. The feeling that something else must be wrong.
                </p>
              </div>
              {/* Why Everything You've Tried Hasn't Worked Section */}
              <div className="mb-10" data-id="element-82">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-83">
                  Why Your PCOS Treatments Aren't Fixing Your Legs
                </h2>
                {/* Traditional Compression Stockings Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-84">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vZgTaXaxfHgpWtLhRDNWGn/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_30_%CF%80.%CE%BC..png" alt="Traditional medical-grade compression stockings next to a frustrated woman trying to put them on" className="w-full h-auto" data-id="element-85" />
                </div>
                <p className="mb-4" data-id="element-86">
                  Once I understood I had both PCOS and lipedema, the next
                  question was obvious: What do I do about it?
                </p>
                <p className="mb-4" data-id="element-87">
                  My doctor recommended compression stockings. You know, those
                  thick medical stockings that are impossible to put on. They
                  cut off your circulation. They look like something your
                  grandmother would wear.
                </p>
                <p className="mb-4" data-id="element-88">
                  I tried them. Honestly? They made things worse.
                </p>
                <p className="mb-4" data-id="element-89">
                  Here's why standard compression doesn't work for lipedema:
                </p>
                <div className="bg-red-50 p-4 rounded-md mb-6" data-id="element-90">
                  <p className="font-semibold mb-2" data-id="element-91">The PCOS Problem</p>
                  <p className="mb-3" data-id="element-92">
                    When you have PCOS, you're already dealing with insulin
                    resistance and inflammation. Adding uncomfortable
                    compression that you can't wear all day doesn't help.
                  </p>
                  <p className="mb-3" data-id="element-93">
                    You need something that works WITH your PCOS management. Not
                    against it.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-94">
                    The One-Size-Fits-All Problem
                  </p>
                  <p className="mb-3" data-id="element-95">
                    Most compression garments use uniform pressure from top to
                    bottom. They squeeze your legs with the same intensity
                    everywhere.
                  </p>
                  <p className="mb-3" data-id="element-96">
                    But your legs aren't uniform. They have natural curves.
                    Different tissue densities. Varying fluid buildup zones.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-97">The Tourniquet Effect</p>
                  <p className="mb-3" data-id="element-98">
                    When compression is too tight or applied wrong, it creates a
                    tourniquet effect. This traps fluid instead of moving it.
                  </p>
                  <p className="mb-3" data-id="element-99">
                    You end up with more swelling at the compression line. Your
                    legs look and feel worse.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-100">
                    They're Uncomfortable and Obvious
                  </p>
                  <p className="mb-3" data-id="element-101">
                    Let's be real. Traditional compression stockings are thick.
                    Hot. Uncomfortable. They scream "medical device."
                  </p>
                  <p className="mb-3" data-id="element-102">
                    You can't wear them under normal clothes. You can't wear
                    them with a dress or shorts.
                  </p>
                  <p className="mb-3" data-id="element-103">
                    So women don't wear them. And if you're not wearing the
                    solution, it's not solving anything.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-104">
                    They Don't Address Both Conditions
                  </p>
                  <p className="mb-3" data-id="element-105">
                    Your PCOS creates hormonal inflammation. Your lipedema
                    creates lymphatic dysfunction. You need support that
                    addresses BOTH.
                  </p>
                  <p className="mb-3" data-id="element-106">
                    Standard compression only addresses one issue. Or neither.
                  </p>
                </div>
                <p className="mb-4" data-id="element-107">
                  I felt stuck. The only "solution" was something I couldn't
                  stand to wear. It didn't even work that well. And it made me
                  feel more self-conscious about my legs.
                </p>
                <p className="mb-4" data-id="element-108">
                  That's when I realized the problem wasn't compression itself.
                  It was the wrong kind of compression.
                </p>
                <p className="mb-4" data-id="element-109">There had to be something better.</p>
              </div>
              {/* The Breakthrough Section */}
              <div className="mb-10" data-id="element-110">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-111">
                  The Breakthrough That Changed Everything
                </h2>
                {/* Elivara Leggings Product Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-112">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qXr4YxNDa3ZLDxwoFvkcy4/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_34_%CF%80.%CE%BC..png" alt="Elivara compression leggings showing the stylish design with FlowMapping™ technology zones highlighted" className="w-full h-auto" data-id="element-113" />
                </div>
                <p className="mb-4" data-id="element-114">
                  That's when I discovered Elivara. Specifically, their
                  FlowMapping™ Compression technology.
                </p>
                <p className="mb-4" data-id="element-115">
                  When I first heard about it, I was skeptical. Another
                  compression product? Really?
                </p>
                <p className="mb-4" data-id="element-116">
                  But Elivara is different from anything else on the market.
                </p>
                <p className="mb-4" data-id="element-117">
                  The difference comes down to one key insight: Your body has
                  natural pathways for lymphatic drainage. Compression needs to
                  follow those pathways — not fight against them.
                </p>
                <p className="mb-4" data-id="element-118">Here's how FlowMapping™ actually works:</p>
                <p className="mb-4" data-id="element-119">
                  Instead of applying uniform pressure across your entire leg,
                  Elivara uses graduated pressure zones. These zones are
                  designed to match your body's lymphatic system.
                </p>
                <p className="mb-4" data-id="element-120">
                  Think of it like this: Your lymphatic fluid needs to move in a
                  specific direction. Up and out of your legs. Back toward your
                  core.
                </p>
                <p className="mb-4" data-id="element-121">
                  FlowMapping™ creates a gentle pressure gradient. This guides
                  trapped fluid along your natural drainage pathways. It speeds
                  up lymphatic flow without creating that uncomfortable
                  tourniquet effect.
                </p>
                <p className="mb-4" data-id="element-122">
                  The pressure is strongest at your ankles (where fluid pools
                  the most). It gradually decreases as it moves up your leg.
                </p>
                <p className="mb-4" data-id="element-123">
                  This gradient naturally encourages fluid to move upward and
                  drain properly. Rather than getting stuck.
                </p>
                <p className="mb-4" data-id="element-124">
                  But here's what really sets Elivara apart: They designed these
                  specifically for women with lipedema. Including women with
                  PCOS + lipedema.
                </p>
                <p className="mb-4" data-id="element-125">
                  Most compression garments are made for generic swelling. Or
                  medical conditions that affect the elderly.
                </p>
                <p className="mb-4" data-id="element-126">
                  Elivara spent years studying lipedema. Understanding the
                  unique fat distribution patterns. The specific areas where
                  fluid builds up. The tender zones where pressure needs to be
                  gentler.
                </p>
                <p className="mb-4" data-id="element-127">
                  And they understand that women with PCOS need something they
                  can wear comfortably while managing their other symptoms.
                </p>
                <p className="mb-4" data-id="element-128">
                  The result? Leggings that deliver therapeutic-level relief
                  while looking and feeling like regular athleisure wear.
                </p>
                <p className="mb-4 font-semibold" data-id="element-129">
                  I'm not exaggerating when I say these changed my life.
                </p>
              </div>
              {/* Visual Explanation of FlowMapping™ Technology */}
              <div className="mb-10" data-id="element-130">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-131">
                  See the FlowMapping™ Difference
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden bg-blue-50 p-4" data-id="element-132">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ge5gzuHf48wNS9HaJaGCz/gempages_541671622348637232-7a3a123c-f1c8-4b25-b1a4-f051e570e74b.webp" alt="Animation showing the difference between painful lipedema fluid buildup (left, red areas) and the FlowMapping™ technology directing fluid flow (right, green chevrons)" className="w-full h-auto mx-auto" data-id="element-133" />
                  <div className="flex justify-between mt-4 text-sm md:text-base" data-id="element-134">
                    <div className="text-center w-1/2 border-r border-blue-200 pr-2" data-id="element-135">
                      <p className="font-bold text-red-500 mb-1" data-id="element-136">
                        WITHOUT SUPPORT
                      </p>
                      <p className="text-gray-700" data-id="element-137">
                        Painful fluid buildup and inflammation
                      </p>
                    </div>
                    <div className="text-center w-1/2 pl-2" data-id="element-138">
                      <p className="font-bold text-green-500 mb-1" data-id="element-139">
                        WITH FLOWMAPPING™
                      </p>
                      <p className="text-gray-700" data-id="element-140">
                        Guided fluid drainage along natural pathways
                      </p>
                    </div>
                  </div>
                </div>
                <p className="mb-4 text-sm italic text-gray-600" data-id="element-141">
                  Results may vary. Individual results are not guaranteed and
                  may differ from person to person.
                </p>
                <p className="mb-4" data-id="element-142">
                  This visual shows what makes FlowMapping™ technology
                  revolutionary.
                </p>
                <p className="mb-4" data-id="element-143">
                  On the left, you see what happens in lipedema legs: fluid
                  builds up (shown in red). This creates painful inflammation
                  and swelling that doesn't respond to PCOS treatments.
                </p>
                <p className="mb-4" data-id="element-144">
                  On the right, you see how Elivara's FlowMapping™ technology
                  works. The compression zones (shown as green chevrons) create
                  directional pressure. This guides trapped fluid along your
                  natural lymphatic pathways.
                </p>
                <p className="mb-4" data-id="element-145">
                  This helps your body drain the fluid properly. It reduces
                  swelling. It reduces pain. It reduces that heavy feeling that
                  comes with lipedema.
                </p>
                <p className="mb-4" data-id="element-146">
                  The chevron patterns aren't just for show. They represent the
                  actual directional support built into every pair of Elivara
                  leggings.
                </p>
                <p className="mb-4" data-id="element-147">
                  This is why women with PCOS + lipedema report feeling
                  immediate relief when they put them on. The technology is
                  working with your body's natural systems. Not against them.
                </p>
              </div>
              {/* What It Actually Feels Like Section */}
              <div className="mb-10" data-id="element-148">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-149">
                  What It Actually Feels Like to Wear Them
                </h2>
                {/* Woman Wearing Elivara Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-150">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oMv6AwMrRLHqTtLr2LbQQk/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_36_%CF%80.%CE%BC..png" alt="Smiling woman wearing Elivara leggings while doing everyday activities" className="w-full h-auto" data-id="element-151" />
                </div>
                <p className="mb-4" data-id="element-152">
                  The first time I put on my Elivara leggings, I noticed the
                  difference immediately.
                </p>
                <p className="mb-4" data-id="element-153">
                  They weren't difficult to get on like traditional compression
                  stockings. They felt like... leggings. Comfortable, soft,
                  breathable leggings that I'd want to wear.
                </p>
                <p className="mb-4" data-id="element-154">
                  But within an hour, I felt something I hadn't felt in years:
                  my legs felt lighter.
                </p>
                <p className="mb-4" data-id="element-155">
                  That heavy, swollen feeling I'd gotten used to? It started to
                  ease. The constant aching? It dulled.
                </p>
                <p className="mb-4" data-id="element-156">
                  By the end of the day — when my legs were usually at their
                  worst — they felt better than they normally did first thing in
                  the morning.
                </p>
                <p className="mb-4" data-id="element-157">
                  I started wearing them every day alongside my PCOS management.
                  And the changes kept coming:
                </p>
                <div className="space-y-4 mb-6" data-id="element-158">
                  <div className="flex items-start" data-id="element-159">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-160" />
                    <p data-id="element-161">
                      <span className="font-semibold" data-id="element-162">
                        My legs looked slimmer.
                      </span>{' '}
                      The constant swelling that made my legs appear larger
                      started to reduce. I could see more definition. More
                      shape. Less of that "column" appearance that PCOS
                      treatments never touched.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-163">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-164" />
                    <p data-id="element-165">
                      <span className="font-semibold" data-id="element-166">The pain decreased.</span>{' '}
                      Lipedema legs are often tender and painful to touch. The
                      FlowMapping™ compression reduced inflammation and fluid
                      buildup. Less pain. Less tenderness. Fewer random bruises.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-167">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-168" />
                    <p data-id="element-169">
                      <span className="font-semibold" data-id="element-170">I had more energy.</span>{' '}
                      When you're carrying around excess fluid in your legs all
                      day, it's exhausting. Once that fluid started draining
                      properly, I had more energy to get through my day. To
                      exercise. To manage my PCOS better.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-171">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-172" />
                    <p data-id="element-173">
                      <span className="font-semibold" data-id="element-174">I stopped hiding.</span>{' '}
                      This was the big one. I started wearing dresses again. I
                      went to the beach in shorts. I stopped obsessing over
                      finding the longest pants possible to cover my legs.
                    </p>
                  </div>
                </div>
                <p className="mb-4" data-id="element-175">
                  For the first time in years, I didn't feel like I had to.
                </p>
                <p className="mb-4" data-id="element-176">
                  Elivara gave me something I thought I'd lost forever: the
                  freedom to live normally. While still managing my PCOS.
                </p>
              </div>
              {/* Testimonials Section */}
              <div className="mb-10" data-id="element-177">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-178">
                  Real Women with PCOS + Lipedema, Real Results
                </h2>
                {/* Before/After Results Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-179">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8J75MXwWaCcwc1FvqhjnYB/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_42_%CF%80.%CE%BC..png" alt="Before and after comparison showing 'Without Support' vs 'With Elivara'" className="w-full h-auto" data-id="element-180" />
                </div>
                <p className="mb-4 text-sm italic text-gray-600" data-id="element-181">
                  Results may vary. Individual results are not guaranteed and
                  may differ from person to person.
                </p>
                <p className="mb-6" data-id="element-182">
                  I'm not the only one who's experienced this transformation.
                  Thousands of women with PCOS + lipedema have discovered
                  Elivara. The testimonials are genuinely moving:
                </p>
                <div className="space-y-6 mb-6" data-id="element-183">
                  <TestimonialCard quote="I thought my legs were just PCOS weight. Then I learned I had lipedema too. These leggings finally gave me relief after years of managing PCOS with no results on my legs." author="Michelle T." age="45" location="Denver, CO" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/3y7To7DiABw2UivqWYkvYv/images_%2842%29.jpg" data-id="element-184" />
                  <TestimonialCard quote="I've been treating my PCOS for 8 years. Metformin, low-carb diet, everything. My upper body responded beautifully. But my legs stayed huge and painful. Finding out I also had lipedema changed everything. And Elivara made it manageable. These don't look medical at all — they look like nice leggings. But the relief they provide is incredible." author="Sarah W." age="39" location="Seattle, WA" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZzQbxP1337U3TnJrDfMSW/istockphoto-1290775513-612x612.jpg" data-id="element-185" />
                  <TestimonialCard quote="I cried when I put these on. Not because they hurt — because they felt GOOD. After years of thinking I was failing my PCOS treatment." author="Jessica R." age="42" location="Portland, OR" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5TbK1HAopveddK7FXfLL/mockup-pretty-curvy-latin-woman-600nw-2460705183.webp" data-id="element-186" />
                  <TestimonialCard quote="I have PCOS and lipedema. I've tried every compression stocking on the market. They all cut into my legs. Left marks. Were so uncomfortable I could barely make it through the day. Elivara is completely different. They're soft. They breathe. They reduce my swelling without that horrible tourniquet feeling. And they don't interfere with my PCOS management. I wear them every single day now." author="Melissa J." age="47" location="Miami, FL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/8hW674k71ojpsCMkVCgv6R/Screenshot_2025-09-30_at_00.02.40.png" data-id="element-187" />
                  <TestimonialCard quote="My legs are lighter. My pain is less. And I'm finally seeing results from my PCOS protocol because I'm addressing BOTH conditions. I finally feel like myself again." author="Amanda K." age="38" location="Austin, TX" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hq1HCFwLGMXQeBfL6EFNpY/istockphoto-1180524344-612x612.jpg" data-id="element-188" />
                  <TestimonialCard quote="For years I thought my legs were just stubborn PCOS fat. My doctor kept adjusting my hormones. Trying different medications. But nothing worked. Finding out I had lipedema AND PCOS was validating. But I still didn't know what to do about it. Elivara changed that. The FlowMapping™ technology works. My legs feel lighter. They look better. And most importantly — I'm not in constant pain anymore while managing my PCOS." author="Rebecca L." age="44" location="Nashville, TN" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/vLXJxevCdw389ZygZwFFUQ/Screenshot_2025-09-30_at_00.02.43.png" data-id="element-189" />
                  <TestimonialCard quote="I can travel again without my legs swelling like balloons. Even with my PCOS under control." author="Linda M." age="51" location="Chicago, IL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/nJ43KvrRnAa3kWNkkTfCWz/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_12_12_37_%CF%80.%CE%BC..png" data-id="element-190" />
                  <TestimonialCard quote="Before Elivara, any time I flew or took a long car ride, my legs would swell so badly I could barely walk. Even with perfect PCOS management. Now I wear my Elivara leggings whenever I travel. The difference is night and day. I got back from a trip to Europe — something I never would have attempted before — and my legs felt better than they have in years." author="Patricia D." age="55" location="Boston, MA" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/eb9DbMXxnEv4xRdj6M31AN/Beth_-_living_with_lipedema.webp" data-id="element-191" />
                </div>
              </div>
              {/* Why Elivara Works Section */}
              <div className="mb-10" data-id="element-192">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-193">
                  Why Elivara Works When PCOS Treatments Alone Don't
                </h2>
                <p className="mb-4" data-id="element-194">
                  You might be wondering: What makes Elivara so different from
                  just managing my PCOS better?
                </p>
                <p className="mb-4" data-id="element-195">It comes down to three key factors:</p>
                {/* FlowMapping Technology Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-196">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sngffNnPS6asvvdqPakuVW/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_52_%CF%80.%CE%BC..png" alt="Illustration comparing Traditional Compression vs FlowMapping™ Technology" className="w-full h-auto" data-id="element-197" />
                </div>
                <div className="space-y-6 mb-6" data-id="element-198">
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-199">
                    <h3 className="font-bold text-lg mb-2" data-id="element-200">
                      1. Addresses BOTH Conditions
                    </h3>
                    <p data-id="element-201">
                      Elivara isn't generic compression. It's not just PCOS
                      management. Every single design element addresses the
                      lymphatic dysfunction of lipedema WHILE supporting your
                      PCOS management routine.
                    </p>
                    <p className="mt-2" data-id="element-202">
                      Your PCOS treatments handle the hormones. Elivara handles
                      the lymphatic fluid. Together, you finally see results in
                      your legs.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-203">
                    <h3 className="font-bold text-lg mb-2" data-id="element-204">
                      2. FlowMapping™ Technology
                    </h3>
                    <p data-id="element-205">
                      The graduated pressure system doesn't squeeze your legs
                      randomly. It creates a precise pressure gradient that
                      follows your body's natural lymphatic pathways. It gently
                      guides trapped fluid where it needs to go.
                    </p>
                    <p className="mt-2" data-id="element-206">
                      It's the difference between squeezing a water balloon
                      (which moves the water around without releasing it) and
                      creating a channel that allows the water to drain
                      properly.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-207">
                    <h3 className="font-bold text-lg mb-2" data-id="element-208">
                      3. Lifestyle-First Approach
                    </h3>
                    <p data-id="element-209">
                      Here's what really sets Elivara apart: they understand
                      that a solution only works if you use it.
                    </p>
                    <p className="mt-2" data-id="element-210">
                      That's why these leggings look stylish. Feel comfortable.
                      Work with your life instead of against it.
                    </p>
                    <p className="mt-2" data-id="element-211">
                      You can wear them to work. To the gym. Running errands.
                      Out to dinner. They don't look medical. They don't scream
                      "I have PCOS and lipedema." They look like great leggings
                      — that happen to provide therapeutic-level relief for BOTH
                      conditions.
                    </p>
                  </div>
                </div>
              </div>
              {/* First CTA Section */}
              <div className="mb-10 bg-gray-100 p-6 rounded-lg" data-id="element-212">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-213">
                  This Is Your Chance to Finally Get Relief
                </h2>
                {/* Product Packaging Image */}
                <div className="mb-6 bg-white rounded-lg overflow-hidden" data-id="element-214">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/23Hx8bzAVQ7dcDK8zTNUdC/Trusted_by_Women_Across_the_USA.png" alt="Elivara Lipedema Leggings with premium packaging, 30-day money back guarantee, and free shipping" className="w-full h-auto" data-id="element-215" />
                </div>
                <p className="mb-4" data-id="element-216">
                  Here's something you should know: because of the specialized
                  FlowMapping™ technology and the lipedema-specific design,
                  Elivara can only produce limited quantities of these leggings.
                </p>
                <p className="mb-4" data-id="element-217">
                  And right now, they're offering first-time customers an
                  exclusive opportunity to save 40% off their order.
                </p>
                <p className="mb-4" data-id="element-218">
                  This isn't a permanent discount. It's designed to help women
                  who've been suffering with PCOS + lipedema finally access a
                  solution that works — without the premium price tag that
                  usually comes with specialized medical garments.
                </p>
                <p className="mb-4" data-id="element-219">
                  But here's the reality: these sell out. Fast.
                </p>
                <p className="mb-4" data-id="element-220">
                  When word gets out that there's finally compression that works
                  for lipedema AND feels comfortable enough to wear every day
                  alongside PCOS management, stock disappears in days.
                </p>
                <p className="mb-4" data-id="element-221">
                  When they're gone, you'll have to wait for the next production
                  run to get your hands on a pair.
                </p>
                <p className="mb-4 font-semibold" data-id="element-222">
                  I don't want you to miss this opportunity.
                </p>
                <p className="mb-4" data-id="element-223">
                  If you've spent years managing your PCOS perfectly. If your
                  upper body responded beautifully but your legs stayed
                  stubbornly huge and painful. If you've been told "keep
                  following the protocol" one more time by a doctor who doesn't
                  understand you have TWO conditions. If you're tired of feeling
                  like you're failing when you're doing everything right...
                </p>
                <p className="mb-4" data-id="element-224">This is your chance to change that.</p>
              </div>
              {/* You Deserve Section */}
              <div className="mb-10" data-id="element-225">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-226">
                  You Deserve to Feel Normal Again
                </h2>
                {/* Lifestyle Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-227">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fcFTP9s5La88PDr9GNhj1H/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_56_%CF%80.%CE%BC..png" alt="Woman confidently walking on the beach wearing a dress with compression leggings" className="w-full h-auto" data-id="element-228" />
                </div>
                <p className="mb-4" data-id="element-229">
                  I want you to imagine something for a moment.
                </p>
                <p className="mb-4" data-id="element-230">
                  Imagine finally understanding why your PCOS treatments never
                  fixed your legs. And having a solution that addresses BOTH
                  conditions.
                </p>
                <p className="mb-4" data-id="element-231">
                  Imagine waking up and putting on leggings that make your legs
                  feel better throughout the day instead of worse.
                </p>
                <p className="mb-4" data-id="element-232">
                  Imagine that heavy, swollen feeling starting to lift. Imagine
                  less pain. Less tenderness. Less constant awareness of your
                  legs as a problem you can't solve no matter how well you
                  manage your PCOS.
                </p>
                <p className="mb-4" data-id="element-233">
                  Imagine wearing a dress in summer without a second thought.
                  Going to the beach. Traveling without fear of your legs
                  swelling. Exercising without the extra discomfort that
                  lipedema brings — even with perfect PCOS control.
                </p>
                <p className="mb-4" data-id="element-234">
                  Imagine living normally. Without constantly wondering why your
                  PCOS protocol isn't working on your legs.
                </p>
                <p className="mb-4" data-id="element-235">
                  That's what Elivara gave me. And that's what it can give you.
                </p>
                <p className="mb-4" data-id="element-236">
                  You're not failing your PCOS treatment. You're not broken. And
                  you're not imagining this problem.
                </p>
                <p className="mb-4" data-id="element-237">
                  You have two conditions. And now there's finally a solution
                  that addresses both.
                </p>
                <p className="mb-6 font-semibold" data-id="element-238">
                  Don't let another doctor tell you to "just manage your PCOS
                  better."
                </p>
                <p className="mb-4" data-id="element-239">
                  Don't wait until they're sold out again. Don't spend another
                  season hiding. Don't let another year go by thinking you're
                  failing when you're doing everything right.
                </p>
                <p className="mb-4" data-id="element-240">
                  Your legs deserve relief. And you deserve to feel confident
                  and comfortable in your own body again.
                </p>
                <div className="mt-8 text-center" data-id="element-241">
                  <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg shadow-md transition-all transform hover:scale-105 inline-block uppercase tracking-wider text-lg" data-id="element-242">
                    DISCOVER ELIVARA & SAVE 40% TODAY →
                  </a>
                </div>
              </div>
              {/* Disclaimer Section */}
              <div className="mb-10 bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-243">
                <h3 className="font-bold text-lg mb-4" data-id="element-244">DISCLAIMER</h3>
                <p className="text-sm text-gray-700 mb-3" data-id="element-245">
                  The information presented in this advertorial is provided for
                  informational and promotional purposes only and should not be
                  construed as medical or professional advice. Results may vary
                  from person to person, and no guarantee is offered regarding
                  outcomes. Always consult a qualified healthcare professional
                  before trying any new solution, method or intervention for
                  health disorders.
                </p>
                <p className="text-sm text-gray-700 mb-3" data-id="element-246">
                  All testimonials included are truthful and come from real
                  clients. Photos and testimonials are for illustrative
                  purposes, but the statements they depict have been verified by
                  our internal team.
                </p>
                <p className="text-sm text-gray-700" data-id="element-247">
                  Women's Health is not responsible for decisions made on the
                  basis of the information contained in this advertorial.
                </p>
              </div>
            </div>
          </main>
          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-248">
            <div className="sticky top-6" data-id="element-249">
              <StickyCTA showNewImage={true} data-id="element-250" />
            </div>
          </aside>
        </div>
      </div>
      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-251">
        <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block" data-id="element-252">
          GET 40% OFF ELIVARA LEGGINGS NOW!
        </a>
      </div>
      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-253">
        <div className="container mx-auto px-4 py-6" data-id="element-254">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-255">
            <div className="flex items-center" data-id="element-256">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-257" />
              <p className="font-bold text-lg" data-id="element-258">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-lg px-4" data-id="element-259">
              Get Elivara Compression Leggings at 40% OFF + FREE Shipping for a
              Limited Time!
            </p>
            <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-base whitespace-nowrap inline-block" data-id="element-260">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="w-full bg-gray-100" data-id="element-261">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-262">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-263">
            <p className="mb-2" data-id="element-264">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-265">
              <span data-id="element-266">About Us</span>
              <span data-id="element-267">|</span>
              <span data-id="element-268">Terms of Use</span>
              <span data-id="element-269">|</span>
              <span data-id="element-270">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-271">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-272">©2025 Women's Health Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};